<template>
    <v-card
        outlined
        class="shop-item__card"
        width="250">

        <v-carousel
                :show-arrows="false"
                height="350"
                delimiter-icon="stop"
                prev-icon="mdi-arrow-left"
                next-icon="mdi-arrow-right">
            <v-carousel-item
                    v-for="(image,i) in productData.images"
                    :key="i"
                    :src="image"
                    height="350">
            </v-carousel-item>
        </v-carousel>

        <v-card-title v-text="productData.name"></v-card-title>
        <v-card-text>
            <div v-text="productData.description"></div>
        </v-card-text>

        <v-divider class="mx-4"></v-divider>

        <v-card-title v-show="!isSoldOut" class="shop-item__card-content-title common__price-color">{{ productData.price }}€</v-card-title>
        <v-card-title v-show="!isSoldOut" class="shop-item__card-content-title">Izmērs</v-card-title>
        <v-card-text>
            <v-chip-group v-show="!isSoldOut"
                    v-model="product.productSelector"
                    active-class="black accent-4 white--text"
                    column>
                <v-chip
                        v-for="(item, index) in availability"
                        :key="index"
                        v-text="item.name"
                        :value="item"
                        :active="item.visible">
                </v-chip>
            </v-chip-group>
            <div v-show="isSoldOut">
                Izpārdots
            </div>
        </v-card-text>

        <v-card-actions class="shop-item__buttons-right">
            <v-btn  :disabled="!product.productSelector"
                    v-show="!isSoldOut"
                    @click="addToCart"
                    class="ma-2"
                    outlined>
                Pievienot <v-icon>mdi-cart-plus</v-icon>
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import { EventBus } from '../../main.js';

    export default {
        name: "ShopItem",
        props: {
            productData: Object
        },
        data() {
            return {
                product: {
                    name: this.productData.name,
                    model: this.productData.model,
                    price: this.productData.price,
                    previewImage: this.productData.images[0],
                    productSelector: null,
                },
                availability: [],
                availabilityInitial: [],
                cartVisible: false
            }
        },
        methods: {
            addToCart: function(){
                EventBus.$emit('shop--add-to-cart', this.product);
                this.product.productSelector = null;
            },

            setUpAvailability: function(){
                this.availableItems();
                this.adjustAvailability();
            },

            availableItems: function(){
                const that = this;
                const availableItemsArray = [];

                for (const property in that.productData.availability) {
                    const entryString = (`${property}: ${that.productData.availability[property]}`);
                    const key = entryString.substring(0, entryString.indexOf(":"));
                    const value = entryString.substring(entryString.indexOf(":") + 2, entryString.length);
                    let visibility = value == 0 ? false : true;

                    const newObj = new Object;
                    newObj.name = key;
                    newObj.ammount = value;
                    newObj.visible = visibility;

                    availableItemsArray.push(newObj);
                }

                that.availability = [];
                that.availabilityInitial = [];
                that.availability = that.availability.concat(availableItemsArray);
                that.availabilityInitial = that.availabilityInitial.concat(availableItemsArray);
            },
            adjustAvailability: function(){
                const that = this;
                let cart = EventBus.cart;
                if(!cart){
                    return;
                }

                cart = cart.filter(function(productInCart){
                    return productInCart.model == that.productData.model;
                });

                that.availability.forEach(function(availableItem){
                    //  Goes through the 3 available items
                    // number of available items initially
                    let initialNumberOfItems = that.availabilityInitial.filter(function(initialAvailableItem){
                        return initialAvailableItem.name === availableItem.name;
                    })
                    let numberOfItems = parseInt(initialNumberOfItems[0].ammount);

                    cart.forEach(function(productInCart){
                        //  Goes through all cart items that match the model
                        //  If
                        // if the item in cart matches the available item - remove one from available items
                        if(availableItem.name === productInCart.productSelector.name){
                            numberOfItems = numberOfItems - 1;

                            if(numberOfItems < 1){
                                availableItem.visible = false;
                            } else {
                                availableItem.visible = true;
                            }
                        }
                    })

                    availableItem.ammount = numberOfItems;

                    if(numberOfItems > 0){
                        availableItem.visible = true;
                    }
                })

            },
        },
        computed: {
            isSoldOut: function(){
                let availableItems = 0;

                this.availability.forEach(function(availabilityItem){
                    availableItems = parseInt(availableItems) + parseInt(availabilityItem.ammount)
                })

                return !availableItems;
            }
        },
        mounted(){
            this.setUpAvailability();
           EventBus.$on('shop--remove-from-cart', this.setUpAvailability);
           EventBus.$on('shop--added-to-cart', this.setUpAvailability);
        }
    }
</script>

<style scoped>
    .shop-item__card-content-title {
        padding: 0 16px;
    }
    .shop-item__card {
        margin: 0 15px 15px;
        align-content: space-between;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .shop-item__buttons-right {
        justify-content: flex-end;
    }
</style>